import { Col } from 'react-bootstrap'
import { styled } from 'styled-components'
import { over } from 'utils'

const SidebarWrapper = styled(Col)<{ $topValue: string }>``

export default SidebarWrapper
